/*
 * The case the current route addresses. Works under both
 * `/clients/:foreignNationalId/cases/:id/*` and `/cases/:id/*` (the individual
 * id keeps the historical `:id` param name); components rendered outside a case
 * route get an empty individual id.
 */
import { useMemo } from "react";
import { useParams } from "react-router-dom";

import {
  type CaseRef,
  type OpenRequest,
  casePath,
  caseWorkspacePath
} from "./routes";

export type CaseRoute = CaseRef & {
  /** A page under the case, e.g. `path("edit")`; no segment = the case root. */
  path: (segment?: string | null) => string;
  workspacePath: (open?: OpenRequest | null) => string;
};

export const useCaseRoute = (): CaseRoute => {
  const { id: individualId = "", foreignNationalId } = useParams<{
    id: string;
    foreignNationalId?: string;
  }>();
  return useMemo(() => {
    const ref: CaseRef = {
      individualId,
      foreignNationalId: foreignNationalId ?? null
    };
    return {
      ...ref,
      path: (segment) => casePath(ref, segment),
      workspacePath: (open) => caseWorkspacePath(ref, open)
    };
  }, [individualId, foreignNationalId]);
};
